import { Injectable } from '@angular/core';
import { Client } from '@df/core/service/client';
import { IListingSizeOption, ListingSize } from '@df/catalog-ui/listing/size/listing-size';
import { LocalStorageService } from '@df/browser/storage/local-storage.service';

@Injectable({ providedIn: 'root' })
export class ListingSizeFactory {
    constructor(private client: Client, private localStorageService: LocalStorageService) {}
    create(options: IListingSizeOption[], defaultSize?: [number, number, number, number]): ListingSize {
        return new ListingSize(this.client, this.localStorageService, options, defaultSize);
    }
}
